import { AccountKind, FeatureFlagKey, FeatureFlagMap, OrgInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Org/Org.Controller.ts
export class OrgsAPI {
  static async getOrg(orgId: number) {
    return APIService.Server.get<OrgInterface>(`/org/${orgId}`);
  }
  static async getAllOrgs() {
    return APIService.Server.get<OrgInterface[]>(`/org/all`);
  }
  static async updateFeatureFlags(orgId: number, featureFlags: FeatureFlagMap) {
    return APIService.Server.patch<OrgInterface>(`/org/${orgId}/feature-flags`, { featureFlags });
  }
  /** One flag on every org at once (`null` = Off). Returns how many orgs were written. */
  static async setFeatureFlagForAllOrgs(key: FeatureFlagKey, value: AccountKind | null) {
    return APIService.Server.patch<{ updated: number }>(`/org/feature-flags/${key}/all`, { value });
  }
  static async avatarsForOrgs(orgIds: string | number[]) {
    const normalizedOrgIds = Array.isArray(orgIds)
      ? orgIds
      : orgIds
          .split(",")
          .map((orgId) => Number(orgId.trim()))
          .filter((orgId) => Number.isFinite(orgId));

    return APIService.Server.get<{ [orgId: number]: string }>(`/org/avatars`, {
      orgIds: normalizedOrgIds
    });
  }
  static async createOrg(org: Partial<OrgInterface>) {
    return APIService.Server.post<OrgInterface>(`/org`, org);
  }
  // static async getParentId(orgId: number | OrgInterface) {
  //     return APIService.Server.get<number>(`/org/${orgId}/parent-id`);
  // }
}
